import React from 'react';
import styled, { css } from 'styled-components';
import { SCREENS_MAX } from '../responsive';
import tw from 'twin.macro';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CarLogoImg from '../../../assets/images/car-logo.png';
import CarLogoDarkImg from '../../../assets/images/car-logo-dark.png';
import InstasharingsLogoImg from '../../../assets/images/instasharings-logo.png';
import { getSiteConfig } from '../../constants/siteConfig';
import { getBrand } from '../../constants/brands';
import { isStagingTarget } from '../../../config/runtime-target';
import LenvoyLogo from '../brandLogo/LenvoyLogo';

interface ILogoProps {
  color?: 'white' | 'dark';
  bgColor?: 'white' | 'dark';
  /** Hide the wordmark below the md breakpoint so a navbar search pill can use the width. */
  hideTextBelowMd?: boolean;
}

const LogoContainer = styled.div`
  ${tw`
    flex
    items-center
    gap-2
  `};
`;

const LogoText = styled.div<{ $hideBelowMd?: boolean }>`
  ${tw`
    text-lg
    sm:text-xl
    md:text-2xl
    font-bold
    text-black
    m-1
    whitespace-nowrap
  `};
  ${({ color }: any) => (color === 'white' ? tw`text-white` : tw`text-black`)}
  ${({ $hideBelowMd }) =>
    $hideBelowMd &&
    css`
      @media (max-width: ${SCREENS_MAX.md}) {
        display: none;
      }
    `}
` as any;

const Image = styled.div`
  width: auto;
  ${tw`h-6 md:h-9`};

  img {
    width: auto;
    height: 100%;
  }
`;

function Logo(props: ILogoProps) {
  const { color, bgColor, hideTextBelowMd } = props;
  const siteConfig = getSiteConfig();
  const brand = getBrand();
  const isInstasharings = siteConfig.siteLogoType === 'instasharings';
  const defaultLogo = bgColor === 'dark' ? CarLogoDarkImg : CarLogoImg;
  const brandName =
    isStagingTarget() && brand.showStagingPlaceholderName && !isInstasharings
      ? 'Your Logo Here'
      : siteConfig.siteName;

  if (brand.id === 'lenvoy') {
    // Lenvoy lockup: reversed (paper) on the navy navbar, navy on light surfaces.
    const tone = color === 'white' || bgColor === 'dark' ? 'dark' : 'light';
    return (
      <LogoContainer>
        <LenvoyLogo tone={tone} height={30} markOnly={false} />
      </LogoContainer>
    );
  }

  return (
    <LogoContainer>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: `2px solid ${color === 'white' ? 'white' : 'var(--color-black)'}`,
        }}
      >
        <FontAwesomeIcon
          icon={faTag}
          color={color === 'white' ? 'white' : 'var(--color-black)'}
          size="sm"
        />
      </span>
      <LogoText color={color || 'dark'} $hideBelowMd={hideTextBelowMd}>
        {brandName}
      </LogoText>
    </LogoContainer>
  );
}

export default Logo;
